import { Button, SxProps, Theme } from '@mui/material';
import React from 'react';
import { FieldValues } from 'react-hook-form';

interface ButtonProps<K extends FieldValues> {
    type?: 'button' | 'submit' | 'reset';
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    disabled?: boolean;
    children?: React.ReactNode;
    title?: string;
    variant?: 'text' | 'outlined' | 'contained';
    startIcon?: React.ReactNode;
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
    sx?: SxProps<Theme> | undefined
}

const MButton = <K extends FieldValues>(props: ButtonProps<K>) => {
    return (
        <Button
            type={props.type ?? 'button'}
            className={`${props.className ?? ''}`}
            onClick={props.onClick}
            disabled={props.disabled}
            style={props.style}
            title={props.title}
            variant={props.variant}
            startIcon={props.startIcon}
            color={props.color}
            sx={props.sx}
        >
            {props.children}
        </Button>
    );
};


MButton.defaultProps = {
    type: 'button',
    className: '',
    disabled: false,
    children: 'Click me'
};

export default MButton;